
export default function PortfolioSection() {
  const portfolioItems = [
    {
      title: 'Collection Streetwear',
      category: 'Mode',
      image: 'https://public.readdy.ai/ai/img_res/c6be7cf8c4d36f89511fe015aff1dad7.jpg'
    },
    {
      title: 'Campagne Digitale',
      category: 'Marketing',
      image: 'https://readdy.ai/api/search-image?query=Digital%20marketing%20campaign%2C%20social%20media%20content%2C%20modern%20advertising%2C%20creative%20digital%20design%2C%20brand%20promotion%2C%20contemporary%20marketing%20visuals&width=400&height=300&seq=portfolio-2&orientation=landscape'
    },
    {
      title: 'Shooting Photo',
      category: 'Photographie',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fashion%20photoshoot%2C%20model%20wearing%20streetwear%2C%20urban%20photography%20session%2C%20contemporary%20fashion%20photography%2C%20stylish%20portrait%2C%20modern%20fashion%20shoot&width=400&height=600&seq=portfolio-3&orientation=portrait'
    },
    {
      title: 'Design Produit',
      category: 'Design',
      image: 'https://readdy.ai/api/search-image?query=Product%20design%20showcase%2C%20modern%20fashion%20accessories%2C%20contemporary%20design%20elements%2C%20stylish%20product%20photography%2C%20luxury%20item%20design%2C%20innovative%20fashion%20products&width=400&height=400&seq=portfolio-4&orientation=squarish'
    },
    {
      title: 'Art Digital',
      category: 'Art',
      image: 'https://readdy.ai/api/search-image?query=Digital%20art%20creation%2C%20contemporary%20digital%20artwork%2C%20modern%20graphic%20design%2C%20creative%20digital%20illustration%2C%20artistic%20digital%20composition%2C%20innovative%20digital%20art&width=400&height=500&seq=portfolio-5&orientation=portrait'
    },
    {
      title: 'Événement Mode',
      category: 'Événement',
      image: 'https://readdy.ai/api/search-image?query=Fashion%20event%2C%20runway%20show%2C%20fashion%20week%2C%20contemporary%20fashion%20presentation%2C%20stylish%20fashion%20event%2C%20modern%20fashion%20showcase%2C%20luxury%20fashion%20gathering&width=400&height=300&seq=portfolio-6&orientation=landscape'
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-black mb-4">
            Portfolio
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Découvrez nos créations, shootings et projets digitaux qui redéfinissent les codes du luxe moderne.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioItems.map((item, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <div className="text-[#FF6B35] text-sm font-semibold mb-2">
                  {item.category}
                </div>
                <h3 className="text-xl font-bold">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
